<template>
  <div class="completed">
    <v-container class="pa-0 mt-sm-4 mt-md-8">
      <div class="card">
        <v-card
          class="transparent px-4 py-3 px-md-6 pt-10 pb-6"
          elevation="0"
          flat
          tile
        >
          <v-row>
            <!-- Left -->
            <v-col cols="12" lg="7">
              <h3 class="heading-h3">Thanks for registering</h3>
              <p class="b-body-1 mt-1">
                You have registered on the site now you can submit a request for
                receiving money.
              </p>

              <!-- Desktop -->
              <div class="d-flex hidden-xs-only" v-if="false">
                <v-btn
                  @click="goToLoan(1, 1)"
                  class="b-button primary text-capitalize px-8 hidden-xs-only"
                  height="48"
                  elevation="0"
                >
                  Apply for 1 Month Loan
                </v-btn>

                <v-btn
                  @click="goToLoan(2, 2)"
                  class="b-button primary text-capitalize px-8 ml-2 hidden-xs-only"
                  height="48"
                  elevation="0"
                >
                  Apply for Term loan
                </v-btn>
              </div>

              <!-- Mobile -->
              <div class="hidden-sm-and-up" v-if="false">
                <v-btn
                  @click="goToLoan(1, 1)"
                  class="b-button primary text-capitalize mb-2"
                  height="48"
                  block
                  elevation="0"
                >
                  Apply for 1 Month Loan
                </v-btn>

                <v-btn
                  @click="goToLoan(2, 2)"
                  class="b-button primary text-capitalize"
                  height="48"
                  block
                  elevation="0"
                >
                  Apply for Term loan
                </v-btn>
              </div>
            </v-col>

            <!-- Right -->
            <v-col cols="12" offset-lg="1" lg="4">
              <v-img
                alt="Completed"
                class="completed"
                contain
                src="@/assets/img/public/pages/registration/completed.svg"
                max-width="288"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "LimeLoansCompleted",

  data() {
    return {};
  },

  computed: {
    ...mapState({ auth: "auth" }),
  },

  created() {
    if (this.auth.user.negative_classification || !this.auth.user.can_apply) {
      this.$router.push({ name: "DashboardRefusalPage" });
    } else {
      this.setProductId(1);
      this.setNumberOfRepayments(1);
      sessionStorage.setItem("lime_show_loan_type_toggle", "1");
      this.$router.replace({
        name: "CreateLoanApplicationPage",
        query: { loantype: "1month" },
      });
    }
  },

  mounted() {},

  methods: {
    ...mapMutations({
      setProductId: "createLoanApplication/setProductId",
      setNumberOfRepayments: "createLoanApplication/setNumberOfRepayments",
    }),

    // goToLoan
    goToLoan(productId, numberOfRepayments) {
      this.setProductId(productId);
      this.setNumberOfRepayments(numberOfRepayments);

      this.$router.push({
        name: "CreateLoanApplicationPage",
        query: { loantype: productId === 1 ? "1month" : "term" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
